export default __webpack_public_path__ + "static/media/selected_tractor_user_faulty.5badbdc8.svg";